
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component({})
export default class ListItem extends Vue {
  @Prop({ default: "default" }) variant: string;
}
